import { render, staticRenderFns } from "./Financial-Advisory.vue?vue&type=template&id=243df192&scoped=true&"
import script from "./Financial-Advisory.vue?vue&type=script&lang=js&"
export * from "./Financial-Advisory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243df192",
  null
  
)

export default component.exports